import { useTranslation } from 'react-i18next';

import { Badge } from '@saas-kit/ui';

interface Props {
  isActive: boolean;
}

export function UserStatusBadge({ isActive }: Props): JSX.Element {
  const { t } = useTranslation('adminUsers');
  return (
    <Badge variant={isActive ? 'success' : 'warning'}>
      {t(isActive ? 'status.active' : 'status.suspended')}
    </Badge>
  );
}
